  <template>
    <CContainer>
      <h3>Historial de pedidos</h3>
      <CCard
        class="bg-light border-0 mt-4 mb-1">
        <CCardBody>
          <CDropdown
            color="dark"
            :caret="false"
            class="d-inline-block">
            <template v-slot:toggler>
              <CButton
                color="dark"
                variant="outline">
                <CIcon name="cil-cloud-download"/>
                <span class="align-middle ml-2">Descargar</span>
              </CButton>
            </template>
            <CDropdownItem>
              <json-excel
                :fields="fileFields"
                :data="items"
                name="historialpedidos.xls"
                class="w-100">
                Excel
              </json-excel>
            </CDropdownItem>
            <CDropdownItem>
              <json-excel
                :fields="fileFields"
                :data="items"
                type="csv"
                name="historialpedidos.csv"
                class="w-100">
              CSV
            </json-excel>
            </CDropdownItem>
          </CDropdown>
        </CCardBody>
      </CCard>
      <CCard class="mt-4">
        <CCardBody class="p-3">
          <CDataTable
            class="mx-3"
            :items="items"
            :fields="fields"
            :tableFilter="{label: 'Buscar: ', placeholder:'Digite el dato a buscar' }"
            :items-per-page="10"
            hover
            pagination>
            <template #Valor_Total="{item}">
              <td align="right">{{formatter.format(item.Valor_Total, 0)}}</td>
            </template>
            <template #Estado_Pedido="{item}">
              <td v-if="item.Estado_Pedido == 'CA'">Cargado</td>
              <td v-if="item.Estado_Pedido == 'EM'">Entregado</td>
              <td v-if="item.Estado_Pedido == 'AU'">Autorizado</td>
              <td v-if="item.Estado_Pedido == 'PE'">Pendiente</td>
              <td v-if="item.Estado_Pedido == 'PA'">Parcial</td>
              <td v-if="item.Estado_Pedido == 'TO'">Total</td>
              <td v-if="item.Estado_Pedido == 'AL'">Alistamiento</td>
              <td v-if="item.Estado_Pedido == 'RE'"></td>
            </template>
            <template #Fecha_Emision="{item}">
              <td align="right">{{item.Fecha_Emision}}</td>
            </template>
            <template #btn="{item}">
              <td>
                <a href="#"
                  class="m-2"
                  @click="getMovimientos(item.Id_Pedido)">
                  <CIcon name="cil-clipboard" class="text-dark" size="lg"/>
                </a>
                <a href="#"
                  class="m-2"
                  @click="printDocumentPDF(item.Id_Pedido)">
                  <CIcon name="cib-adobe-acrobat-reader" class="text-danger" size="lg"/>
                </a>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
      </CCard>

      <CModal
          title=""
          color="dark"
          :show.sync="detailModal"
          :centered="true"
          :closeOnBackdrop="false"
          :backdrop="true"
          size="lg">
          <template v-slot:header>
            <h4>Movimientos de pedido</h4>
          </template>
          <template v-slot:body-wrapper>
              <CContainer class="p-4">                    
                <div v-if="loading">
                  Esto puede tardar unos minutos... Por favor espere.     
                  <div class="spinner-border"></div>                  
                </div>
                <CDataTable
                  v-if="!loading"
                  :items="movementItems"
                  :fields="movementFields"
                  hover>
                  <template #Valor_Total="{item}">
                    <td align="right">{{formatter.format(item.Valor_Total, 0)}}</td>
                  </template>
                  <template #Valor_Producto="{item}">
                    <td align="right">{{formatter.format(item.Valor_Producto, 0)}}</td>
                  </template>
                </CDataTable>
              </CContainer>
          </template>
          <template v-slot:footer>
            <CButton
                color="info"
                square 
                class="mr-2 d-inline-block"
                @click="
                  detailModal=false
                  movementItems=[]">
                OK
              </CButton>
          </template>
        </CModal>
        <!-- <CModal
          title=""
          color="dark"
          :show.sync="loading"
          :centered="true"
          :closeOnBackdrop="false"
          :backdrop="true">
          <template v-slot:header>
              <h4></h4>
          </template>
          <template v-slot:body-wrapper>
              <CContainer class="p-4">                    
                <div>
                  Esto puede tardar unos minutos... Por favor espere.     
                  <div class="spinner-border"></div>                  
                </div>
              </CContainer>
          </template>
          <template v-slot:footer>
              <span></span>
          </template>
        </CModal> -->
      <CElementCover v-show="loading"/>    
    </CContainer>
</template>

<script>
  import JsonExcel from 'vue-json-excel'
  import { formatter } from '../../general'
  import { 
    downloadFileObject, 
    dataGridPedidos, 
    dataPedidoMovimientos 
  } from '../../api'
  import { descargarCotizacionPDF } from '../../apiReports'

  const fields = [
    { key: 'Dependencia', label: 'Dependencia/CenCos', _style:'text-align:center;' },
    { key: 'Numero', label: 'Número', _style:'text-align:center;' },
    { key: 'Fecha_Emision', label: 'Emisión', _style:'text-align:center;' },
    { key: 'Valor_Total', label: 'Vr. Total', _style:'text-align:center;' },
    { key: 'Estado_Pedido', label: 'Estado', _style:'text-align:center;' },
    { key: 'btn', label: '', _style: 'text-aling:center' }
  ]

  const fileFields = {
    'Fecha Emisión': 'Fecha_Emision', 
    'Número': 'Numero', 
    'Dependencia': 'Dependencia',
    'Valor Total': 'Valor_Total', 
    'Estado Pedido': {
      field: 'Estado_Pedido',
      callback(value){
        switch (value) {
          case 'CA':
            return 'Cargado'
          case 'EM':
            return 'Entregado'
          case 'AU':
            return 'Autorizado'
          case 'PE':
            return 'Pendiente'
          case 'PA':
            return 'Parcial'
          case 'TO':
            return 'Total'
          case 'AL':
            return 'Alistamiento'
        }
      }
    }
  }

  const movementItems = []

  const movementFields = [
    { key:"Codigo", label: "Codigo", _style: 'text-align:center;' },
    { key: "Descripcion", label: "Descripcion", _style: 'text-align:center;' },
    { key: "Referencia", label: "Presentacion", _style: 'text-align:center;' },
    { key: "Cantidad", label: "Cantidad", _style: 'text-align:center;' },
    { key: "Valor_Producto", label: "Valor Producto", _style: 'text-align:center;' },
    { key: "Valor_Total", label: "Valor Total", _style: 'text-align:center;' },
  ]

  export default {
    name: 'HistoricOrders',
    data () {
      return {
        formatter,
        loading: false,
        items:[],
        fields,
        fileFields,
        detailModal: false,
        movementItems,
        movementFields
      }
    },
    components: { JsonExcel },
    methods:{
      async getData() {        
        try {
          this.loading = true
          const data = await dataGridPedidos(this, this.$store.state.user.data.id_Directorio)
          this.items = data.response
        } catch {
          this.$store.commit('setAlert', {
            color: "danger",
            message: 'Error al cargar datos',
            show: 5
          })
        } finally {
          this.loading = false
        }
      },
      async getMovimientos(idOrder) {
        if (idOrder) {
          try {
            this.detailModal = true
            this.loading = true
            const { response } = await dataPedidoMovimientos(this, idOrder)
            this.movementItems = response
          } catch {
            this.$store.commit('setAlert', {
              color: "danger",
              message: 'Error al cargar datos',
              show: 5
            })
          } finally {
            this.loading = false
          }
        }
      },
      async printDocumentPDF(idDocument) {
        this.loading = true

        try {
          const { response } = await descargarCotizacionPDF(this, idDocument)
          const { nombreArchivo, contenidoArchivo } = response

          downloadFileObject(nombreArchivo, "pdf", contenidoArchivo)
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: "Ocurrio un error al generar el archivo PDF.",
            show: 5
          })
        } finally {
          this.loading = false
        }
      }
    }, 
    mounted(){
      this.getData()
    } 
  }
</script>